import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

// Components
import { FooterComponent } from './components/footer/footer.component';
import { TopnavigationComponent } from './components/topnavigation/topnavigation.component';

// NG2 Charts
import { ChartsModule } from 'ng2-charts';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';

import { NodeService } from './services/nodeservice.service';
import { MessageService } from './services/messageservice.service';

// Directives
import { MatchHeightDirective } from './directives/match-height.directive';

@NgModule({
    declarations: [
        MatchHeightDirective,
        FooterComponent,
        TopnavigationComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ChartsModule,
        ButtonModule,
        CalendarModule,
        CheckboxModule,
        DialogModule,
        DropdownModule,
        FileUploadModule,
        InputTextModule,
        InputTextareaModule,
        MessagesModule,
        MessageModule,
        MultiSelectModule,
        PasswordModule,
        RadioButtonModule,
        TableModule,
        TreeTableModule
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DatePipe,
        MatchHeightDirective,
        ChartsModule,
        ButtonModule,
        CalendarModule,
        CheckboxModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        MessagesModule,
        MessageModule,
        MultiSelectModule,
        PasswordModule,
        RadioButtonModule,
        TableModule,
        TreeTableModule,
        FooterComponent,
        TopnavigationComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [NodeService, MessageService]
        };
    }
}
